export const useAudio = (): [(url: string, callback: Function) => void] => {
    const playAudio = (url: string, callback: Function): void => {
        const audio = new Audio(url);
        audio.loop = false;
        void audio.play();
        audio.onended = () => {
            callback();
        };
    };

    return [playAudio];
};

export const playAudioAsync = async (audio: HTMLAudioElement): Promise<any> => {
    return await new Promise((resolve) => {
        try {
            void audio.play().catch(() => resolve(null));
            audio.onended = resolve;
        } catch (er) {
            console.error(er);
            return resolve(null);
        }
    });
};
